import Backbone from 'backbone'
import { callbackHandler } from '../../manager/view.handler'

// 템플릿
import goodsDetailTpl from './template/goodsDetail.mustache'
import messageTpl from './template/message.mustache'
import moneyLimitInfoTpl from './template/moneyLimitInfo.mustache'
import pointDetailTpl from './template/pwgPointDetail.mustache'
import receiptTpl from './template/receipt.mustache'
import vipCouponsTpl from './template/vipCoupons.mustache'

export var PopupView = Backbone.View.extend({
  template: {
    message: messageTpl,
    receipt: receiptTpl,
    goodsDetail: goodsDetailTpl,
    moneyLimitInfo: moneyLimitInfoTpl,
    pointDetail: pointDetailTpl,
    vipCoupons: vipCouponsTpl,
  },
  initialize: function () {
    // this.model.off()
    this.model.on('change:isVisible', this.togglePopup, this)
  },
  events: {
    'click [data-callback]': callbackHandler,
  },
  togglePopup: function () {
    this.render()
    if (this.model.get('isVisible')) {
      this.$el.show()
    } else {
      this.$el.empty().hide()
    }
  },
  render: function () {
    var template = this.template[this.model.get('template')]
    var rendered = template.render(this.model.toJSON())
    this.$el.empty().html(rendered)
    return this
  },
})
